import React from 'react';
import StyledTypography from './components/StyledTypography';
import Episode1Image1 from '../../../images/features/local_delivery/episode1/LP_01.jpg';
import Episode1Image2 from '../../../images/features/local_delivery/episode1/LP_02.jpg';
import Episode1Image3 from '../../../images/features/local_delivery/episode1/LP_03.jpg';
import Episode1Image4 from '../../../images/features/local_delivery/episode1/LP_04.jpg';
import Episode1Image5 from '../../../images/features/local_delivery/episode1/LP_05.jpg';
import Episode1Image6 from '../../../images/features/local_delivery/episode1/LP_06.jpg';
import Episode2Image1 from '../../../images/features/local_delivery/episode2/LP_01.jpg';
import Episode2Image2 from '../../../images/features/local_delivery/episode2/LP_02.jpg';
import Episode2Image3 from '../../../images/features/local_delivery/episode2/LP_03.jpg';
import Episode2Image4 from '../../../images/features/local_delivery/episode2/LP_04.jpg';
import Episode2Image5 from '../../../images/features/local_delivery/episode2/LP_05.jpg';
import Episode2Image6 from '../../../images/features/local_delivery/episode2/LP_06.jpg';
import Episode2Image7 from '../../../images/features/local_delivery/episode2/LP_07.jpg';
import Episode2Image8 from '../../../images/features/local_delivery/episode2/LP_08.jpg';
import Episode3Image1 from '../../../images/features/local_delivery/episode3/LP_01.jpg';
import Episode3Image2 from '../../../images/features/local_delivery/episode3/LP_02.jpg';
import Episode3Image3 from '../../../images/features/local_delivery/episode3/LP_03.jpg';
import Episode3Image4 from '../../../images/features/local_delivery/episode3/LP_04.jpg';
import Episode3Image5 from '../../../images/features/local_delivery/episode3/LP_05.jpg';
import Episode4Image1 from '../../../images/features/local_delivery/episode4/LP_01.jpg';
import Episode4Image2 from '../../../images/features/local_delivery/episode4/LP_02.jpg';
import Episode4Image3 from '../../../images/features/local_delivery/episode4/LP_03.jpg';
import Episode4Image4 from '../../../images/features/local_delivery/episode4/LP_04.jpg';
import Episode4Image5 from '../../../images/features/local_delivery/episode4/LP_05.jpg';
import Episode5Image1 from '../../../images/features/local_delivery/episode5/LP_01.jpeg';
import Episode5Image2 from '../../../images/features/local_delivery/episode5/LP_02.jpeg';
import Episode5Image3 from '../../../images/features/local_delivery/episode5/LP_03.jpeg';
import Episode5Image4 from '../../../images/features/local_delivery/episode5/LP_04.jpeg';
import Episode6Image1 from '../../../images/features/local_delivery/episode6/LP_01.jpeg';
import Episode6Image2 from '../../../images/features/local_delivery/episode6/LP_02.jpeg';
import Episode6Image3 from '../../../images/features/local_delivery/episode6/LP_03.jpeg';
import Episode6Image4 from '../../../images/features/local_delivery/episode6/LP_04.jpeg';
import Episode7Image1 from '../../../images/features/local_delivery/episode7/LP_01.jpg';
import Episode7Image2 from '../../../images/features/local_delivery/episode7/LP_02.jpg';
import Episode7Image3 from '../../../images/features/local_delivery/episode7/LP_03.jpg';
import Episode7Image4 from '../../../images/features/local_delivery/episode7/LP_04.jpg';
import Episode7Image5 from '../../../images/features/local_delivery/episode7/LP_05.png';
import Episode1AdminImage from '../../../images/features/local_delivery/episode1/admin.jpeg';
import Episode2AdminImage from '../../../images/features/local_delivery/episode2/admin.jpg';
import Episode3AdminImage from '../../../images/features/local_delivery/episode3/admin.jpg';
import Episode4AdminImage from '../../../images/features/local_delivery/episode4/admin.jpg';
import Episode5AdminImage from '../../../images/features/local_delivery/episode5/admin.jpeg';
import Episode6AdminImage from '../../../images/features/local_delivery/episode6/admin.jpeg';
import Episode7AdminImage from '../../../images/features/local_delivery/episode7/admin.jpg';
import { LOCAL_DELIVERY } from '../variables';

export const LINE_SHARE_CONTENT = `真田・森田のローカルデリバリー\n7ORDERがおてつたびを通じて、日本各地のお手伝いをするTV番組START!!\n\n#おてつたび #7ORDER #ローカルデリバリー`;
export const TWITTER_SHARE_CONTENT = `#7ORDER #真田佑馬 さん #森田美勇人 さんが\n#おてつたび で日本各地をお手伝い🚚\n#真田・森田のローカルデリバリー #スペシャプラス\n\n${LOCAL_DELIVERY}`;

export const TYPOGRAPHY_COLOR = '#333333';
export const PRIMARY_COLOR = '#EB6429';
export const SECONDARY_COLOR = '#FAD790';
export const BUTTON_SHADOW_COLOR = '#CE4204';
export const OUTLINE_COLOR = '#333333';
export const DIVIDER_COLOR = '#D0D0D0';
export const DIVIDER_REGISTER_COLOR = '#F5D799';
export const BORDER_COLOR_SANADA_SAN = '#CB162F';
export const BORDER_COLOR_MORITA_SAN = '#EBCA2A';
export const BACKGROUND_BASE_COLOR = '#FDF9EA';
export const BACKGROUND_GRID_COLOR = '#F5D79940';
export const BACKGROUND_NUMBER_COLOR = '#FAD79066';
export const SUBTITLE_COLOR = '#DC7242';

export const ABOUT_ID = 'about';
export const ON_AIR_ID = 'on_air';
export const OTETSUTABI_LIST_ID = 'otetsutabi_list';

// オンエアリスト
export const OTETSUTABI_LIST_DATA = [
  {
    order: 7,
    key: '7',
    planId: null, // 募集を作成しないので、nullで定義する
    businessName: '下部温泉 古湯坊源泉舘',
    address: '山梨県南巨摩郡身延町',
    adminImage: Episode7AdminImage,
    position: '女将',
    name: '依田由有子 さん',
    description: (
      <StyledTypography>
        源泉舘の『武田信玄公かくし湯大岩風呂』は1300年前から多くの人々の傷や病を癒してきました。
        戦国時代には武田信玄公が許可証を発行し、温泉を大切に守ってきたという資料も残っています。
        現在では、手術後の傷や火傷などの外傷性の傷病に良いとされ、全国から多くのお客様が湯治を目的に来られます。
        足下から湧き出る、約30℃の源泉が浴槽を満たしているため、循環・加水・加温を一切していない「本物の温泉」に入浴することができます。
        源泉に優しく包まれる不思議な感覚を、是非体験してみてください！
      </StyledTypography>
    ),
    tasks: 'お掃除やベッドメイクなど旅館内のお手伝い全般',
    terms: [],
    termText: '募集開始時に“いち早く“お知らせしますのでフォローお願いします！',
    images: [
      Episode7Image1,
      Episode7Image2,
      Episode7Image3,
      Episode7Image4,
      Episode7Image5,
    ],
  },
  {
    order: 6,
    key: '6',
    planId: null, // 募集を作成しないので、nullで定義する
    businessName: '365BASE outdoor hostel',
    address: '静岡県浜松市',
    adminImage: Episode6AdminImage,
    position: '代表',
    name: '古橋啓稔 さん',
    description: (
      <StyledTypography>
        アパレル経験10年の僕が、2015年に不動産仲介業として独立し、浜松の魅力を世界中に発信していきたいと2017年に始めた宿が
        『365BASE outdoor hostel』です。
        浜松は全国の政令指定都市の中で一番面積が大きく、海・山・川・湖に囲まれた街。サーフィンや釣り、川遊びやカヤックなどたくさんのアウトドアが楽しめるスポットがたくさんあります。
        そんな浜松だからこそ、アウトドアというコンセプトの宿をつくりました。ぜひお手伝いお越しください！
      </StyledTypography>
    ),
    tasks: 'ベッドメーキング・部屋掃除・アイデア出しなど',
    terms: [],
    termText: '募集開始時に“いち早く“お知らせしますのでフォローお願いします！',
    images: [Episode6Image1, Episode6Image2, Episode6Image3, Episode6Image4],
  },
  {
    order: 5,
    key: '5',
    planId: 749,
    businessName: '株式会社漁師鮮度',
    address: '大阪府阪南市',
    adminImage: Episode5AdminImage,
    position: '代表取締役',
    name: '岩井克巳 さん',
    description: (
      <StyledTypography>
        大阪府阪南市でカキ養殖管理・出荷を行なっております。冬場にはカキ小屋、カキのオフシーズンには観光漁業事業なども行なっております。10〜20代も多く活気ある職場です。将来漁師になりたい方、漁業に興味のある方歓迎いたします！繁忙期で忙し時期ですが、一緒に「波有手のカキ小屋」を盛り上げていただきたいです！
      </StyledTypography>
    ),
    tasks: 'カキ小屋で接客や調理補助',
    terms: ['2月10日(木) 〜 2月13日(日)'],
    images: [Episode5Image1, Episode5Image2, Episode5Image3, Episode5Image4],
  },
  {
    order: 4,
    key: '4',
    planId: 745,
    businessName: '一般社団法人アジラボ',
    address: '茨城県ひたちなか市',
    adminImage: Episode4AdminImage,
    position: 'コミュニティマネージャー',
    name: '小池伸秋 さん',
    description: (
      <StyledTypography>
        一般社団法人アジラボは「100年先も豊かに暮らせる海（街）をつくる」をビジョンに掲げ、ワーケーションやイベントなどを通して新たな海岸文化を生み出す団体です。
        海岸に季節を問わず人が集い、癒しを得る場所へと変え、人に愛される海があり、夢を持った者が集う、そんな新しい海岸文化をここ阿字ヶ浦から創造していきます。
        海辺のコワーキングスペースである「イバフォルニア・ベース」を拠点に、ワーケーションやイベントのお手伝いをしてみませんか？
      </StyledTypography>
    ),
    tasks: 'イベントのお手伝い',
    terms: ['2022年1月19日(水) 〜 1月24日(土)'],
    images: [
      Episode4Image1,
      Episode4Image2,
      Episode4Image3,
      Episode4Image4,
      Episode4Image5,
    ],
  },
  {
    order: 3,
    key: '3',
    planId: 613,
    businessName: '中伊豆ワイナリーヒルズ',
    address: '静岡県伊豆市',
    adminImage: Episode3AdminImage,
    position: '工場責任者',
    name: '松本智康 さん',
    description: (
      <StyledTypography>
        静岡県伊豆市でワイン製造をぶどう栽培から一貫して行っています。
        伊豆は雨も多く、温暖な気候のため、ぶどう栽培には決して適地とは言い難い土地ですが、様々な工夫と努力により美味しいワインをお客様にお届けできるように頑張っています。
        是非伊豆にお越しいただき、お手伝い通して、伊豆の魅力を知ってもらえたら嬉しいです。
      </StyledTypography>
    ),
    tasks: 'ワイン用ぶどう樹管理・SNSでプロモーションのお手伝い',
    terms: ['日程：2021年12月9日(木) 〜 12月11日(土) 2名定員'],
    images: [
      Episode3Image1,
      Episode3Image2,
      Episode3Image3,
      Episode3Image4,
      Episode3Image5,
    ],
  },
  {
    order: 2,
    key: '2',
    planId: null, // 募集を作成しないので、nullで定義する
    businessName: 'NIPPONIA 小菅 源流の村',
    address: '山梨県北都留郡小菅村',
    adminImage: Episode2AdminImage,
    position: 'マネージャー',
    name: '谷口峻哉 さん',
    description: (
      <StyledTypography>
        小菅村は、多摩川源流に位置する面積の95％が森林と豊かな自然に囲まれた人口約700人の小さな村です。人口が、ピーク時の3分の1にまで減少するなど、深刻な過疎高齢化に直面しています。この美しい自然と村の文化を後世に残していくため、過疎化と空き家の課題解決と観光資源を生かせるモデルとして「700人の村が一つのホテルに。」をコンセプトに、地域全体を一つの宿に見立てる分散型古民家ホテル「NIPPONIA小菅
        源流の村」をオープンしました。運営するスタッフは全員が村人であり、食材もほとんどが小菅村の農家が栽培したものを用います。
        お手伝いを通じて、村の生活を感じていただけたらと思います。
      </StyledTypography>
    ),
    tasks: 'お掃除やベッドメイクなど',
    terms: [],
    termText: '募集開始時に“いち早く“お知らせしますのでフォローお願いします！',
    images: [
      Episode2Image1,
      Episode2Image2,
      Episode2Image3,
      Episode2Image4,
      Episode2Image5,
      Episode2Image6,
      Episode2Image7,
      Episode2Image8,
    ],
  },
  {
    order: 1,
    key: '1',
    planId: 523,
    businessName: 'ベジフルファーム',
    address: '千葉県富里市',
    adminImage: Episode1AdminImage,
    position: '農場長',
    name: '加藤 遼亮さん',
    description: (
      <>
        <StyledTypography>
          ベジフルファームは、メタルロックを聴かせた小松菜等を販売するなど、農業革命を起こしている次世代ハイブリッド農家集団です。地域のスーパーや学校給食、直売所、加工業者向けに小松菜やにんじん、大根、ミニトマトなどを供給する農業生産事業をはじめ、直売、広告、コンサルティングなど幅広く事業を展開しています。
        </StyledTypography>
        <StyledTypography>
          農業のリアルな現場を感じていただければと思います。
        </StyledTypography>
        <StyledTypography>
          大変な作業と共にお待ちしております。
        </StyledTypography>
      </>
    ),
    tasks: '小松菜の収穫',
    terms: ['2021年9月29日(水)　2名定員'],
    images: [
      Episode1Image1,
      Episode1Image2,
      Episode1Image3,
      Episode1Image4,
      Episode1Image5,
      Episode1Image6,
    ],
  },
];

export const ON_AIR_DATES: Array<Array<string>> = [
  ['#1', '2021/ 9/19(日)', 'リピート放送 10/10(日)'],
  ['#2', '2021/10/17(日)', 'リピート放送 11/14(日)'],
  ['#3', '2021/11/21(日)', 'リピート放送 12/12(日)'],
  ['#4', '2021/12/19(日)', 'リピート放送  1/ 9(日)'],
  ['#5', '2022/ 1/16(日)', 'リピート放送  2/13(日)'],
  ['#6', '2022/ 2/20(日)', 'リピート放送  3/13(日)'],
  ['#7', '2022/ 3/20(日)', 'リピート放送  4/10(日)'],
];
